import * as ConcorsandoApi from "../../lib/ConcorsandoApi";
import _ from 'lodash'
import AppSingleton from "../../helpers/AppSingleton";
import {AUTH_MUTATIONS} from "./mutations-enum";
import {AUTH_ACTIONS, AUTH_ACTIONS_DISPATCH} from "./actions-enum";
import {COMPETITION_ACTIONS_DISPATCH} from "../competition/actions-enum";
import {PATH_ACTIONS_DISPATCH} from "../path/actions-enum";
import Worker from "@/lib/ConcorsandoWasm/WrappedWorker";
import {UTILITY_ACTIONS_DISPATCH} from "@/store/utility/actions-enum";
import {AUTH_GETTERS_DISPATCH} from "@/store/auth/getters-enum";
import {NOTIFICATIONS_ACTIONS_DISPATCH} from "@/store/notifications/actions-enum";
import {NotificationStorage} from "@/helpers/NotificationStorage"; 
import AffiliateManager, {AFFILIATE_CODE_PARAM_NAME} from "../../lib/AffiliateManager";
import { getAppCheckHeader } from "../../lib/appCheckUtils";

const worker = Worker.instance

export async function signup ({ dispatch, commit, state, rootGetters }, payload) {
    // Recupero il token App Check prima della registrazione
    const apiInstance = new ConcorsandoApi.UtenteApi()
    await getAppCheckHeader(apiInstance.apiClient);
    
    return new Promise((resolve, reject) => {
        const profile = rootGetters[AUTH_GETTERS_DISPATCH.PROFILE]
        const body = new ConcorsandoApi.UtenteVO()
        const authVO = new ConcorsandoApi.AutenticazioneVO()

        body.email_comunicazioni = payload.emailComunicazioni
        body.flag_privacy = payload.flag_privacy
        const affiliate_code = AffiliateManager.instance.getAffiliateString();
        if (affiliate_code && affiliate_code !== "") {
            body[AFFILIATE_CODE_PARAM_NAME] = affiliate_code;
        }

        authVO.dispositivo = "web"
        authVO.sistemaOperativo = window.navigator.appVersion
        authVO.versioneApp = process.env.VUE_APP_VERSION
        authVO.social = payload.social

        if (payload.isSignup !== undefined && payload.isSignup) {
            authVO.username = payload.username
            authVO.password = payload.password
        } else {
            authVO.token_social = payload.tokenSocial
        }

        body.autenticazioneVO = authVO
        apiInstance.registrazione(body, (error, data, response) => {
            if (error) {
                reject(error)
            } else {
                if (response.status === 200) {
                    AffiliateManager.instance.clearAffiliateString();
                    if (profile !== undefined && profile !== null && profile.id_utente_concorsando !== undefined && profile.id_utente_concorsando !== response.body.id_utente_concorsando) {
                        dispatch(AUTH_ACTIONS.CLEAR_AUTH, { clearUserData: true });
                    }
                    _setupAuthentication({dispatch, commit, state}, response.body, response.body.autenticazioneVO.social, response.body.autenticazioneVO.token_social)
                        .then(() => {
                            // Salviamo utente attivo per il SW e carichiamo le notifiche
                            try {
                                NotificationStorage.setActiveUser(response.body.id_utente_concorsando);
                                dispatch(NOTIFICATIONS_ACTIONS_DISPATCH.LOAD_NOTIFICATIONS, response.body.id_utente_concorsando, { root: true });
                            } catch (e) {
                                console.error("Errore salvataggio utente attivo/notifiche:", e);
                            }
                            
                            resolve(response)
                        })
                        .catch(reject)
                } else {
                    reject(response)
                }
            }
        });
    })
}

export function logout ({ dispatch }, payload) {
    let clearUserData = true
    if (payload !== undefined && payload !== null) {
        if (
            (payload.errorCode !== undefined && payload.errorCode !== null && (payload.errorCode === 401 || payload.errorCode === 403))
            || (payload.clearUserData !== undefined && payload.clearUserData !== null && !payload.clearUserData)
        ) {
            clearUserData = false
        }
    }

    const apiInstance = new ConcorsandoApi.UtenteApi();
    apiInstance.logout(() => {});
    
    // Rimuoviamo utente attivo per il SW
    try {
        NotificationStorage.clearActiveUser();
    } catch (e) {
        console.error("Errore rimozione utente attivo:", e);
    }
    
    return dispatch(AUTH_ACTIONS.CLEAR_AUTH, { clearUserData: clearUserData });
}

export async function login({ dispatch, commit, state, rootGetters }, payload) {
    // Recupero il token App Check prima del login
    const apiInstance = new ConcorsandoApi.UtenteApi();
    await getAppCheckHeader(apiInstance.apiClient);
    
    return new Promise((resolve, reject) => {
        const profile = rootGetters[AUTH_GETTERS_DISPATCH.PROFILE]
        const bodyRequest = new ConcorsandoApi.AutenticazioneVO()

        if (payload.isLogin !== undefined && payload.isLogin) {
            bodyRequest.username = payload.username
            bodyRequest.password = payload.password
        } else {
            bodyRequest.token_social = payload.tokenSocial
        }

        bodyRequest.dispositivo = "web"
        bodyRequest.sistemaOperativo = window.navigator.appVersion
        bodyRequest.versioneApp = process.env.VUE_APP_VERSION
        bodyRequest.social = payload.social

        apiInstance.login(bodyRequest, (error, data, response) => {
            if (error) {
                if (error.response !== undefined) {
                    if (error.response.status === 401) {
                        _setupAuthentication({dispatch, commit, state}, response, payload.social, (payload.isLogin) ? response.social : bodyRequest.token_social, payload)
                            .then(() => resolve(response.body))
                            .catch(reject)
                        return
                    }
                }
                reject(error)
            } else {
                if (response.status === 200) {
                    if (profile !== undefined && profile !== null && profile.id_utente_concorsando !== undefined && profile.id_utente_concorsando !== response.body.id_utente_concorsando) {
                        dispatch(AUTH_ACTIONS.CLEAR_AUTH, { clearUserData: true });
                    }
                    _setupAuthentication({dispatch, commit, state}, response.body, payload.social, (payload.isLogin) ? response.body.social : bodyRequest.token_social, payload)
                        .then(() => {
                            // Salviamo utente attivo per il SW e carichiamo le notifiche
                            try {
                                NotificationStorage.setActiveUser(response.body.id_utente_concorsando);
                                dispatch(NOTIFICATIONS_ACTIONS_DISPATCH.LOAD_NOTIFICATIONS, response.body.id_utente_concorsando, { root: true });
                            } catch (e) {
                                console.error("Errore salvataggio utente attivo/notifiche:", e);
                            }

                            resolve(response.body)
                        })
                        .catch(reject)
                } else {
                    reject(response)
                }
            }
        });
    })
}

export async function updateAuthenticationStatus({ dispatch, commit, state }, payloadProfile) {
    const profile = payloadProfile || state.profile;
    const social = _.get(profile, "autenticazioneVO.social");
    const tokenSocial = _.get(profile, "autenticazioneVO.token_social");
    await _setupAuthentication({dispatch, commit, state}, profile, social, tokenSocial);
    if (profile && profile.id_utente_concorsando) {
        // Ripristiniamo anche qui in caso di refresh pagina
        try {
            NotificationStorage.setActiveUser(profile.id_utente_concorsando);
            dispatch(NOTIFICATIONS_ACTIONS_DISPATCH.LOAD_NOTIFICATIONS, profile.id_utente_concorsando, { root: true });
        } catch (e) {
            console.error("Errore ripristino notifiche:", e);
        }
    }
}

function _isEncrypted(token) {
    return token && token.length > 60 && /^[0-9a-fA-F]+$/.test(token);
}

export async function _setupAuthentication({dispatch, commit, state}, profile, social, tokenSocial, payload) {
    if (profile.token_api !== undefined && profile.token_api !== null && profile.token_api !== "") {
        let clearToken = profile.token_api;
        let encryptedTokenHex = profile.token_api;
        
        const isEncrypted = _isEncrypted(profile.token_api);

        if (isEncrypted && !state.decrypted) {
            // Caso Restore: Decriptiamo il token per l'ApiClient
            try {
                const encryptedBytes = new Uint8Array(profile.token_api.match(/.{1,2}/g).map(byte => parseInt(byte, 16)));
                clearToken = await worker.decryptRaw(encryptedBytes);
            } catch (e) {
                console.error("Errore decriptazione token:", e);
                // Se fallisce la decriptazione, facciamo logout per sbloccare il router
                // che sta aspettando 'decrypted: true' o 'isAuthenticated: false'
                dispatch(AUTH_ACTIONS.CLEAR_AUTH, { clearUserData: true });
                return;
            }
        } else if (!isEncrypted) {
            // Caso Login/Signup o GetUser con token in chiaro: Lo criptiamo per lo store
            try {
                const encryptedBytes = await worker.encryptRaw(profile.token_api);
                encryptedTokenHex = _.reduce(encryptedBytes, (res, val) => res + val.toString(16).padStart(2, '0'), '');
            } catch (e) {
                console.error("Errore criptazione token:", e);
            }
        } else if (isEncrypted && state.decrypted) {
            // È già criptato e siamo già decriptati, recuperiamo il token in chiaro dall'ApiClient
            // per evitare di reimpostare quello criptato come apiKey
            const existingKey = ConcorsandoApi.ApiClient.instance.authentications['Baerer'].apiKey;
            if (existingKey && existingKey !== profile.token_api) {
                clearToken = existingKey;
            } else {
                try {
                    const encryptedBytes = new Uint8Array(profile.token_api.match(/.{1,2}/g).map(byte => parseInt(byte, 16)));
                    clearToken = await worker.decryptRaw(encryptedBytes);
                } catch (e) {
                    console.error("Errore decriptazione token (fallback):", e);
                }
            }
        }

        const Baerer = ConcorsandoApi.ApiClient.instance.authentications['Baerer'];
        Baerer.apiKey = clearToken;
        Baerer.apiKeyPrefix = 'Bearer';

        // Segnaliamo che il token è pronto e decriptato (in memoria)
        commit(AUTH_MUTATIONS.SET_DECRYPTED, true);

        const profileToSave = _.cloneDeep(profile);
        profileToSave.token_api = encryptedTokenHex;
        
        commit(AUTH_MUTATIONS.SET_PROFILE, profileToSave)
        commit(AUTH_MUTATIONS.SET_IS_AUTHENTICATED, !!profile.email_verificata)

        commit(AUTH_MUTATIONS.SET_AUTHENTICATIONS, {
            token_api: encryptedTokenHex,
            social: social,
            tokenSocial: tokenSocial,
            email: payload ? payload.email : (state.authentications.email || null),
            name: payload ? payload.name : (state.authentications.name || null),
        })
    } else {
        commit(AUTH_MUTATIONS.SET_AUTHENTICATIONS, {
            token_api: null,
            social: social,
            tokenSocial: tokenSocial,
            email: payload ? payload.email : (state.authentications.email || null),
            name: payload ? payload.name : (state.authentications.name || null),
        })
    }
}

export function clearAuth({ dispatch, commit }, payload) {
    commit(AUTH_MUTATIONS.UNSET_IS_AUTHENTICATED)
    const Baerer = ConcorsandoApi.ApiClient.instance.authentications['Baerer'];
    Baerer.apiKey = ''
    Baerer.apiKeyPrefix = '';
    commit(AUTH_MUTATIONS.UNSET_AUTHENTICATIONS)
    commit(AUTH_MUTATIONS.SET_DECRYPTED, false)
    if (payload.clearUserData) {
        dispatch(AUTH_ACTIONS.CLEAR_USER_DATA);
    }
    localStorage.removeItem('hello')
}

export function clearUserData({dispatch, commit}) {
    commit(AUTH_MUTATIONS.UNSET_PROFILE)
    dispatch(UTILITY_ACTIONS_DISPATCH.CLEAR_UPTIME, null, {root: true})
    dispatch(COMPETITION_ACTIONS_DISPATCH.CLEAR_COMPETITIONS_ENTITIES, null, { root: true })
    dispatch(PATH_ACTIONS_DISPATCH.CLEAR_PATHS, null, { root: true })
    worker.clearAll()
}

export function verifyErrorType ({ dispatch }, payload) {
    return new Promise((resolve, reject) => {
        if (payload.response !== undefined) {
            if (payload.response.status === 401 || payload.response.status === 403) {
                dispatch(AUTH_ACTIONS.LOGOUT, { errorCode: payload.response.status })
                    .finally(AppSingleton.instance.$router.push({ name: 'Auth', query: { type: 'login' }}))
            } else {
                reject()
            }
        } else {
            reject()
        }
    })
}

export function getRestorePassword ({ dispatch }, payload) {
    return new Promise((resolve, reject) => {
        let apiInstance = new ConcorsandoApi.UtenteApi();
        apiInstance.inviaRichiestaRecuperoPassword(payload, (error, data, response) => {
            if (error) {
                if (error.response !== undefined) {
                    if (error.response.status === 404) {
                        reject(404)
                    } else {
                        reject()
                    }
                } else {
                    reject()
                }
            } else {
                if (response.status === 204) {
                    resolve()
                } else {
                    reject()
                }
            }
        });
    })
}

export function sendRestorePassword ({ dispatch }, payload) {
    return new Promise((resolve, reject) => {
        let apiInstance = new ConcorsandoApi.UtenteApi();
        let token = payload.token; // String | il token generato per poter effettuare il cambio della password
        let password = payload.password; // String | la nuova password da utilizzare

        apiInstance.cambiaPasswordDaRichiesta(token, password, (error, data, response) => {
            if (error) {
                dispatch(AUTH_ACTIONS_DISPATCH.VERIFY_ERROR_TYPE, error, { root: true })
                    .catch(() => reject(error))
            } else {
                if (response.status === 204) {
                    resolve()
                } else {
                    reject()
                }
            }
        });
    })
}
